export function formatEventName(event: string): string {
  return event.replace(/([a-z])([A-Z])/g, '$1 $2');
}
